export const ReportState = {
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    LOADING: "LOADING",
}